import { lazy, Suspense } from "react";
import { CircularProgress, Box } from "@mui/material";
import { BugReport } from "@mui/icons-material";
import type { ModuleDescriptor } from "src/app/moduleDescriptor";
import { buildModuleRegistry, type ModuleFileExports } from "src/app/moduleRegistry";
import { IframeTestPage } from "src/pages/IframeTestPage/IframeTestPage.page";

function pageLoadingFallback() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
      <CircularProgress aria-label="Loading page" />
    </Box>
  );
}

// Lazy-loaded: a dev-only debugging tool, rarely visited — same choice
// insights-home makes for its own Debug page.
const DebugPageLazy = lazy(() =>
  import("src/pages/DebugPage/DebugPage.page").then((m) => ({ default: m.DebugPage }))
);

const featureModuleFiles = import.meta.glob<ModuleFileExports>("../features/*/*.module.tsx", {
  eager: true,
});

const appPages: ModuleDescriptor[] = [
  {
    id: "debug",
    path: "/debug",
    element: (
      <Suspense fallback={pageLoadingFallback()}>
        <DebugPageLazy />
      </Suspense>
    ),
    nav: { label: "JWT Debug", icon: <BugReport />, section: "secondary" },
  },
  {
    // Demo/test page — reached via direct URL only, no nav entry.
    id: "iframe-test",
    path: "/iframe-test",
    element: <IframeTestPage />,
  },
];

/**
 * Module registry: the one list routing and the drawer render from. Feature
 * modules are discovered from each feature's `<feature>.module.tsx` by the
 * glob above, so adding a feature needs no edit here; `appPages` lists only
 * the app-level pages. Adding a page: docs/guides/app-shell.md "Add a page".
 * Reference: insights-home src/app/router.tsx (eager page imports).
 */
export const modules: ModuleDescriptor[] = buildModuleRegistry(featureModuleFiles, appPages);
